import React from "react";

//interfaces
import { ActionFeedback } from "../../../../interfaces/toasts/ActionFeedback";

//components
import Icon from "../../../global/icons/Icon";

//helpers
import { getActionFeedbackIcon } from "../../../../helpers/IconLibrary";



const ActionFeedbackBanner = ({feedbackType, feedbackMessage}:{feedbackType: ActionFeedback, feedbackMessage: string}) => {

    if (!feedbackType) {
        return <></>
    }
    return (
        <div className={`action-feedback-wrapper ${feedbackType}`} >
            <Icon iconName={getActionFeedbackIcon(feedbackType)} sizeInPx="12" color="white" />

            {feedbackMessage && <span className="action-feedback-message">{feedbackMessage}</span>}       
        </div>
    );
};

export default ActionFeedbackBanner 